import { ActionCallbackOnly } from "store/model";

import { Actions, ActionScanSessionHandler, IValidationScanSessionMessageCallback, IValidationStartScanSessionCallback, type ScanSessionPurpose } from "./types";



export const startScanSession = (
  startScanSessionCallback: IValidationStartScanSessionCallback,
  scanSessionMessageCallback: IValidationScanSessionMessageCallback,
  productId?: string,
  // VRG-265 — omitted means 'certificate' (the API's own default), so every existing call site
  // is unchanged. Pass 'filter' to open the read-only session scan-to-filter uses.
  purpose?: ScanSessionPurpose,
): ActionScanSessionHandler => ({
  type: Actions.START_SCAN_SESSION,
  startScanSessionCallback,
  scanSessionMessageCallback,
  productId,
  purpose,
});

export const endScanSesion = (callback?: any): ActionCallbackOnly => ({
  type: Actions.END_SCAN_SESSION,
  callback
});
